/* tslint:disable */
/* eslint-disable */
/**
 * B2B Air Booking
 * Endpoints needed to complete air booking  # Tracking Metrics * `b2bportal.availability.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.availability.prediction.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.availability.prediction.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.availability.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.availability.volume`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.booking.product.error`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.mytrips.get.failure`   * tags: `api_version`, `error_code`, `product`, `tenantid` * `b2bportal.mytrips.get.success`   * tags: `api_version`, `product`, `tenantid` * `b2bportal.quote.product.error`   * tags: `api_version`, `error_code`, `product`, `quote_action`, `tenantid`   # Tracking Error Codes * `application_error` * `bad_request` * `check_in_minimum_age_not_met` * `duplicate_booking` * `duplicated_national_id` * `duplicated_passport` * `excessive_activity` * `expired_national_id` * `expired_passport` * `expiring_national_id` * `expiring_passport` * `extra_bags_error` * `illegal_lap_infant_ktn` * `illegal_lap_infant_redress` * `inactivity` * `ineligible` * `internal_error` * `invalid_customer` * `invalid_passenger_name` * `invalid_passengers` * `invalid_passport_number` * `invalid_passport_or_national_id_number` * `lap_infant_too_old` * `lap_infants_unsupported` * `malformed_known_traveler_number` * `malformed_redress_number` * `missing_airline_locator` * `missing_national_id` * `missing_nationality` * `missing_passport_number` * `missing_passport_or_national_id` * `missing_passport` * `no_adult_passenger` * `no_availability` * `no_contact_information` * `no_ticketless_response` * `passenger_name_too_short` * `passenger_not_found` * `passthrough_payment_error` * `provider_error` * `request_deserialization_error` * `response_serialization_error` * `restricted_city` * `restricted_country` * `seated_infants_unsupported` * `session_closed` * `shop_async_error` * `ticketing_not_started` * `ticketing_unconfirmed` * `ticketing_unknown` * `too_many_lap_infants` * `too_many_passengers` * `transient_service_error` * `unexpected_passengers` * `unknown_sabre_app_error` * `unknown` * `unsupported_name_characters` * `unsupported_payment_kind` * `upgrade_required` * `user_not_found`
 *
 * The version of the OpenAPI document: v9p177
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';

export const BASE_PATH = "http://localhost".replace(/\/+$/, "");

/**
 *
 * @export
 */
export const COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};

/**
 *
 * @export
 * @interface RequestArgs
 */
export interface RequestArgs {
    url: string;
    options: RawAxiosRequestConfig;
}

/**
 *
 * @export
 * @class BaseAPI
 */
export class BaseAPI {
    protected configuration: Configuration | undefined;

    constructor(configuration?: Configuration, protected basePath: string = BASE_PATH, protected axios: AxiosInstance = globalAxios) {
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath ?? basePath;
        }
    }
};

/**
 *
 * @export
 * @class RequiredError
 * @extends {Error}
 */
export class RequiredError extends Error {
    constructor(public field: string, msg?: string) {
        super(msg);
        this.name = "RequiredError"
    }
}

interface ServerMap {
    [key: string]: {
        url: string,
        description: string,
    }[];
}

/**
 *
 * @export
 */
export const operationServerMap: ServerMap = {
}
